import { render, staticRenderFns } from "./answeringAi.vue?vue&type=template&id=21164948&scoped=true"
import script from "./answeringAi.vue?vue&type=script&lang=js"
export * from "./answeringAi.vue?vue&type=script&lang=js"
import style0 from "./answeringAi.vue?vue&type=style&index=0&id=21164948&prod&lang=less&scoped=true"
import style1 from "./answeringAi.vue?vue&type=style&index=1&id=21164948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21164948",
  null
  
)

export default component.exports